<ng-container *ngIf="{
    row: columnData | async,
    keyname: keyName | async
  } as $">
<span *ngIf="$.row && $.keyname" >{{$.row[$.keyname] | number:'1.2-2'}}</span>
</ng-container>